var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElephantSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 187,
    viewBox: "0 0 163 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.132 51.6685C129.558 35.67 118.035 21.7739 103.158 14.3086C88.2814 6.84312 70.2785 5.88613 54.6839 11.7283C47.6538 14.3714 40.9588 18.4871 36.5827 24.5744C32.2065 30.6613 30.4705 38.9722 33.3936 45.8831C35.8327 51.6568 41.0997 55.7985 46.7511 58.511C49.9009 60.0117 53.202 61.1362 56.6079 61.8663C63.8849 64.237 72.5176 63.987 77.3454 61.9313C80.7889 60.465 83.2015 57.4912 84.4793 54.0469C85.1231 52.313 85.5153 50.4914 85.6841 48.6485C85.889 46.4784 85.3346 44.262 85.509 42.0664C85.5456 41.6032 85.8107 40.809 86.4281 41.208C87.6491 41.9728 87.8903 44.4588 88.1813 45.7365C89.3795 51.2019 88.9075 56.9499 85.6489 61.6852C81.8193 67.3643 74.2525 69.2046 67.3958 69.1461C56.2103 69.0234 45.3862 65.0878 36.7116 58.0178C32.9681 54.9402 29.1677 51.089 24.3168 51.0333C21.5587 51.0011 18.9784 52.2554 16.5652 53.5357C-2.36448 63.659 -24.9968 81.5877 -22.777 105.634C-22.1761 112.211 -19.7876 118.415 -17.375 124.492C-14.9625 130.569 -12.4726 136.691 -11.7095 143.237C-11.5162 144.925 -11.4423 146.607 -11.4981 148.305C-11.5494 150.059 -11.8989 151.706 -12.2038 153.413C-12.3753 154.381 -12.4742 155.474 -12.0744 156.413C-12.0043 156.578 -11.9012 156.729 -11.7884 156.856C-7.1159 141.728 -7.81508 126.007 -7.81508 126.007L-7.44569 126.92C-7.48941 126.588 -7.52413 126.233 -7.56796 125.902C-5.83598 127.364 -4.14639 128.863 -2.42383 130.349C8.33956 140.13 15.2512 153.848 22.0596 166.501C23.0758 168.385 24.2025 170.299 25.7555 171.798C27.2782 173.272 28.9432 174.256 31.0985 173.65C32.9928 173.116 35.0313 172.189 36.8199 171.408C39.4067 170.306 42.029 169.151 44.6205 167.969C39.4767 144.37 48.3607 135.293 50.1138 133.787C53.8066 130.346 59.0195 128.554 64.2911 129.736C70.5687 131.13 73.7423 136.572 77.2015 141.406C78.6782 143.366 79.9948 145.452 81.4977 147.381C82.9631 149.268 84.7786 150.15 87.1846 149.904C88.396 149.777 90.6606 148.696 91.7506 148.193C92.93 147.672 94.0927 147.157 95.2721 146.635C96.3267 146.186 97.3905 145.714 98.4451 145.265C84.3482 101.05 98.894 77.0663 105.601 68.9551C106.148 68.1381 106.794 67.4153 107.539 66.787C108.222 66.1065 108.621 65.7618 108.621 65.7618L108.693 66.0229C110.242 65.2271 112.147 65.0386 113.624 65.9474C115.024 66.8113 115.728 68.419 116.324 69.956C119.79 79.0102 121.533 88.6812 125.543 97.5039C129.553 106.327 136.55 114.578 146.015 116.601C149.246 117.288 153.722 116.278 153.955 112.987C154.106 110.781 152.212 109.077 150.622 107.535C143.564 100.652 140.42 90.6628 138.818 80.9124C137.209 71.146 136.856 61.1748 134.132 51.6685ZM103.148 42.945C103.89 45.3734 102.513 47.9451 100.078 48.6708C97.6421 49.3965 95.0774 48.0361 94.3517 45.6006C93.6096 43.1722 94.9864 40.6005 97.422 39.8749C99.8505 39.1323 102.406 40.5166 103.148 42.945C103.148 42.945 103.141 42.9286 103.148 42.945Z",
    fill: "url(#paint0_linear_22_743)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4301 145.272C98.8419 145.097 99.2376 144.928 99.6494 144.753C101.961 143.827 104.026 142.461 104.585 139.887C105.056 137.702 103.881 135.263 103.103 133.298C95.6914 114.887 94.9645 88.9981 104.16 71.4185C104.597 70.5704 105.064 69.7487 105.602 68.9551C98.8721 77.0564 84.3331 101.057 98.4301 145.272Z",
    fill: "url(#paint1_linear_22_743)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4301 145.272C98.8419 145.097 99.2376 144.928 99.6494 144.753C101.961 143.827 104.026 142.461 104.585 139.887C105.056 137.702 103.881 135.263 103.103 133.298C95.6914 114.887 94.9645 88.9981 104.16 71.4185C104.597 70.5704 105.064 69.7487 105.602 68.9551C98.8721 77.0564 84.3331 101.057 98.4301 145.272Z",
    fill: "url(#paint2_linear_22_743)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.62 167.97C44.9333 167.837 45.2462 167.703 45.5523 167.554C47.897 166.477 49.0537 164.486 48.9021 161.981C48.7294 159.427 47.8465 156.942 47.0149 154.532C46.2325 152.238 45.3163 149.903 44.9974 147.508C44.3069 142.138 46.4654 137.151 50.0735 133.785C48.3435 135.3 39.4668 144.394 44.62 167.97Z",
    fill: "url(#paint3_linear_22_743)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.62 167.97C44.9333 167.837 45.2462 167.703 45.5523 167.554C47.897 166.477 49.0537 164.486 48.9021 161.981C48.7294 159.427 47.8465 156.942 47.0149 154.532C46.2325 152.238 45.3163 149.903 44.9974 147.508C44.3069 142.138 46.4654 137.151 50.0735 133.785C48.3435 135.3 39.4668 144.394 44.62 167.97Z",
    fill: "url(#paint4_linear_22_743)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-11.7635 156.865C-11.651 156.992 -11.4961 157.082 -11.3386 157.132C-10.2387 157.383 -9.45424 155.707 -9.06211 154.936C-8.3746 153.534 -7.98296 151.985 -7.5939 150.476C-7.00056 148.121 -6.74803 145.698 -6.83153 143.261C-6.94824 137.822 -6.77546 132.376 -7.40716 126.962L-7.77656 126.049C-7.78316 126.032 -7.09101 141.737 -11.7635 156.865Z",
    fill: "url(#paint5_linear_22_743)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-11.7635 156.865C-11.651 156.992 -11.4961 157.082 -11.3386 157.132C-10.2387 157.383 -9.45424 155.707 -9.06211 154.936C-8.3746 153.534 -7.98296 151.985 -7.5939 150.476C-7.00056 148.121 -6.74803 145.698 -6.83153 143.261C-6.94824 137.822 -6.77546 132.376 -7.40716 126.962L-7.77656 126.049C-7.78316 126.032 -7.09101 141.737 -11.7635 156.865Z",
    fill: "url(#paint6_linear_22_743)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22_743",
    x1: 0.914586,
    y1: 186.918,
    x2: 168.951,
    y2: 95.3767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8258F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22_743",
    x1: 98.4317,
    y1: 145.276,
    x2: 134.398,
    y2: 128.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8258F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_22_743",
    x1: 98.4317,
    y1: 145.276,
    x2: 134.398,
    y2: 128.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8258F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_22_743",
    x1: 44.62,
    y1: 167.97,
    x2: 62.6988,
    y2: 159.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8258F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_22_743",
    x1: 44.62,
    y1: 167.97,
    x2: 62.6988,
    y2: 159.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8258F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_22_743",
    x1: -11.5276,
    y1: 157.419,
    x2: 3.96383,
    y2: 149.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8258F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_22_743",
    x1: -11.5276,
    y1: 157.419,
    x2: 3.96383,
    y2: 149.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8258F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A8FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElephantSmall);
export default __webpack_public_path__ + "static/media/elephant-small.e384e2a5b69c330cb30e8d2151bb223d.svg";
export { ForwardRef as ReactComponent };